import { injectable } from 'inversify';
import type { User } from '@repositories/userRepository/user.types';
import API from '@repositories/Axios';
import type { IGoogleOauthRepository } from '../IGoogleOauthRepository';
import 'reflect-metadata';
import type { AuthCodeDto } from '../googleOauth.types';

@injectable()
export class GoogleOauthRepository implements IGoogleOauthRepository {
  async signIn(rqData: AuthCodeDto): Promise<User> {
    const result = await API.post<User>(`/api/v1/actions/google/sign-in/redirect`, rqData);
    return result.data;
  }
}
